import { marketplace, locale as localeConfig } from '@sellpy/commons'
import { getRegion } from './region'

export const locale = process.env.LOCALE_OVERRIDE || marketplace.LOCALE[getRegion()]

export const creditFAQLink = localeConfig.creditFAQLink(locale)
export const adyenPrivacyPolicyLink = localeConfig.adyenPrivacyPolicyLink(locale)
export const faqLink = localeConfig.faqLink(locale)
export const localizedMetadata = localeConfig.localizedMetadata(locale)
export const segmentToBaseCategory = localeConfig.segmentToBaseCategory(locale)

export const LOCALIZED_ELASTIC_ITEM_INDEX = {
  sv: 'item',
  de: 'item_de',
  en: 'item_en',
  pl: 'item_pl',
  nl: 'item_nl',
  da: 'item_da',
  fi: 'item_fi',
  fr: 'item_fr',
  cs: 'item_cs'
}[locale]

export const localeBooleansForGQL = (localeOverride) => ({
  isSV: (localeOverride || locale) === 'sv',
  isDE: (localeOverride || locale) === 'de',
  isEN: (localeOverride || locale) === 'en',
  isNL: (localeOverride || locale) === 'nl',
  isDA: (localeOverride || locale) === 'da',
  isPL: (localeOverride || locale) === 'pl',
  isFI: (localeOverride || locale) === 'fi',
  isFR: (localeOverride || locale) === 'fr',
  isCS: (localeOverride || locale) === 'cs'
})
